import { delayDuringHolidayDataEn } from "constants-lib/seo/faqDataImplementation"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getdelayDuringHolidayEn = () => {
  const data = delayDuringHolidayDataEn.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const adddelayDuringHoliday = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/what-kind-of-delay-might-i-expect-during-a-holiday-in-my-area`,
    ) &&
    document.getElementById(`delayDuringHolidayJSONLD`) === null
  ) {
    const script = delayDuringHolidayJSONLDEn()
    addJSONLDToHead(script, `delayDuringHolidayJSONLD`)
  } else {
    removeElement(`delayDuringHolidayJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const delayDuringHolidayJSONLDEn = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getdelayDuringHolidayEn(),
  }
  return FaqBagsterTemplate
}
